import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import SchoolsDirectory from './pages/SchoolsDirectory';
import SchoolPage from './pages/SchoolPage';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import PaymentCancellation from './pages/PaymentCancellation';
import Orders from './pages/Orders';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import Reports from './pages/Reports';
import PaymentsManagement from './pages/PaymentsManagement';
import AdminOrders from './pages/AdminOrders';
import ApiLogs from './pages/ApiLogs';
import ChangePassword from './pages/ChangePassword';
import RefundCancellation from './pages/RefundCancellation';
import ShippingDelivery from './pages/ShippingDelivery';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import GrievanceRedressal from './pages/GrievanceRedressal';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/schools" element={<SchoolsDirectory />} />
          <Route path="/school/:id" element={<SchoolPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="/order-confirmation/:orderId"
            element={
              <PrivateRoute>
                <OrderConfirmation />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment-cancellation/:orderId"
            element={
              <PrivateRoute>
                <PaymentCancellation />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute requireAdmin>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute requireAdmin>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <PrivateRoute requireAdmin>
                <PaymentsManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/orders"
            element={
              <PrivateRoute requireAdmin>
                <AdminOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/api-logs"
            element={
              <PrivateRoute requireAdmin>
                <ApiLogs />
              </PrivateRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route path="/refund-cancellation" element={<RefundCancellation />} />
          <Route path="/shipping-delivery" element={<ShippingDelivery />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
